import React from 'react';
import { Shield } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const Datenschutz = () => {
    return (
        <div style={{
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
            background: 'linear-gradient(135deg, #171B27 0%, #0F121C 100%)',
            color: '#edfaff',
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column'
        }}>
            {/* Header */}
            <Header />

            {/* Content Wrapper */}
            <div style={{
                flex: '1',
                padding: '2rem 1rem',
                paddingTop: '120px'
            }}>
                {/* Content */}
                <div style={{
                    maxWidth: '800px',
                    margin: '0 auto 3rem',
                    background: '#242A3B',
                    borderRadius: '20px',
                    padding: 'clamp(2rem, 5vw, 3rem)',
                    border: '2px solid #30374A'
                }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '1rem',
                        marginBottom: '2rem'
                    }}>
                        <Shield size={40} color="#43F36F" />
                        <h2 style={{
                            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
                            fontWeight: '700',
                            margin: 0,
                            color: '#edfaff'
                        }}>Datenschutzerklärung</h2>
                    </div>

                    <div style={{ lineHeight: '1.8', color: '#596678' }}>
                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>1. Datenschutz auf einen Blick</h3>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Allgemeine Hinweise</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website und unsere VolleyScout App besuchen bzw. nutzen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Datenerfassung auf dieser Website</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                <strong style={{ color: '#edfaff' }}>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
                                Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
                            </p>

                            <p style={{ marginBottom: '1rem' }}>
                                <strong style={{ color: '#edfaff' }}>Wie erfassen wir Ihre Daten?</strong><br />
                                Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in der VolleyScout App eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
                            </p>

                            <p style={{ marginBottom: '1rem' }}>
                                <strong style={{ color: '#edfaff' }}>Wofür nutzen wir Ihre Daten?</strong><br />
                                Die Daten werden erhoben, um eine fehlerfreie Bereitstellung der Website und der App-Funktionen zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden, sofern Sie dem zugestimmt haben.
                            </p>

                            <p style={{ marginBottom: '1rem' }}>
                                <strong style={{ color: '#edfaff' }}>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
                                Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>2. Hosting</h3>

                            <p style={{ marginBottom: '1rem' }}>
                                Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Hostinger</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Anbieter ist die Hostinger International Ltd., 61 Lordou Vironos Street, 6023 Larnaca, Zypern (nachfolgend "Hostinger").
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Details entnehmen Sie der Datenschutzerklärung von Hostinger: <a href="https://www.hostinger.com/de/legal/datenschutz-bestimmungen" target="_blank" rel="noopener noreferrer" style={{
                                color: '#007AFF',
                                textDecoration: 'none'
                            }}>https://www.hostinger.com/de/legal/datenschutz-bestimmungen</a>
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Die Verwendung von Hostinger erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Wir haben ein berechtigtes Interesse an einer möglichst zuverlässigen Darstellung unserer Website.
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>3. Allgemeine Hinweise und Pflichtinformationen</h3>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Datenschutz</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, wie und zu welchem Zweck das geschieht.
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Hinweis zur verantwortlichen Stelle</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Alexander Beitz<br />
                                Hartengrube 58<br />
                                23552 Lübeck<br />
                                Deutschland
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                E-Mail: alex@beitz.me<br />
                                Telefon: +49 179 4156859
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Speicherdauer</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer personenbezogenen Daten haben.
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Widerruf Ihrer Einwilligung zur Datenverarbeitung</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Auskunft, Löschung und Berichtigung</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>4. Datenerfassung auf dieser Website</h3>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Cookies</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Unsere Website verwendet keine Cookies. Die Internetseiten verwenden auch keine anderen Tracking-Technologien.
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Server-Log-Dateien</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                            </p>
                            <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
                                <li>Browsertyp und Browserversion</li>
                                <li>verwendetes Betriebssystem</li>
                                <li>Referrer URL</li>
                                <li>Hostname des zugreifenden Rechners</li>
                                <li>Uhrzeit der Serveranfrage</li>
                                <li>IP-Adresse</li>
                            </ul>
                            <p style={{ marginBottom: '1rem' }}>
                                Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.
                            </p>
                        </section>

                        <section style={{ marginBottom: '2rem' }}>
                            <h3 style={{
                                fontSize: '1.5rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginBottom: '1rem'
                            }}>5. Datenverarbeitung in der VolleyScout App</h3>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Welche Daten werden erfasst?</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Bei der Nutzung der VolleyScout App werden folgende personenbezogene Daten erfasst und verarbeitet:
                            </p>
                            <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
                                <li>Name des Nutzers (Trainer/Co-Trainer)</li>
                                <li>E-Mail-Adresse des Nutzers</li>
                                <li>Namen der erfassten Spieler</li>
                                <li>Spielerpositionen</li>
                                <li>Spielstatistiken (Annahme, Angriff, Aufschlag)</li>
                            </ul>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Zweck der Datenverarbeitung</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die Verarbeitung der genannten Daten ist zwingend notwendig für die Bereitstellung der App-Funktionen:
                            </p>
                            <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
                                <li>Nutzer-Authentifizierung und Account-Verwaltung</li>
                                <li>Speicherung und Verwaltung von Teams und Spielern</li>
                                <li>Erfassung und Auswertung von Spielstatistiken</li>
                                <li>Synchronisation zwischen mehreren Geräten</li>
                                <li>Team-Sharing-Funktion für Co-Trainer</li>
                            </ul>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Rechtsgrundlage</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Bereitstellung der App-Funktionalität).
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Speicherort und Speicherdauer</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Die Daten werden in Google Firebase Firestore gespeichert. Firebase ist ein Dienst der Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA.
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Google verarbeitet Ihre Daten auch in den USA. Google ist Teilnehmer des EU-US Data Privacy Framework. Weitere Informationen finden Sie in der Datenschutzerklärung von Google: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" style={{
                                color: '#007AFF',
                                textDecoration: 'none'
                            }}>https://policies.google.com/privacy</a>
                            </p>
                            <p style={{ marginBottom: '1rem' }}>
                                Die Daten werden gespeichert, solange Sie die App aktiv nutzen. Bei Löschung Ihres Accounts werden alle zugehörigen Daten vollständig aus der Datenbank entfernt.
                            </p>

                            <h4 style={{
                                fontSize: '1.2rem',
                                fontWeight: '600',
                                color: '#edfaff',
                                marginTop: '1.5rem',
                                marginBottom: '0.5rem'
                            }}>Ihre Rechte</h4>
                            <p style={{ marginBottom: '1rem' }}>
                                Sie haben jederzeit das Recht:
                            </p>
                            <ul style={{ marginLeft: '2rem', marginBottom: '1rem' }}>
                                <li>Auskunft über Ihre gespeicherten Daten zu erhalten</li>
                                <li>Die Berichtigung unrichtiger Daten zu verlangen</li>
                                <li>Die Löschung Ihrer Daten zu verlangen</li>
                                <li>Ihren Account und alle zugehörigen Daten zu löschen</li>
                            </ul>
                            <p style={{ marginBottom: '1rem' }}>
                                Zur Ausübung dieser Rechte wenden Sie sich bitte an: alex@beitz.me
                            </p>
                        </section>

                        <section style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #30374A' }}>
                            <p style={{ fontSize: '0.9rem', color: '#596678' }}>
                                Stand: Oktober 2025
                            </p>
                        </section>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default Datenschutz;